import React from 'react';
import PropTypes from 'prop-types';
import { NowPlaying } from './../nowPlaying';
import { Player } from './../player';
import { Link } from 'react-router';
import './headerPlaylist.css';

import logo from '../../../assets/radio-ke.png';
import logo2x from '../../../assets/radio-ke@2x.png';

const HeaderPlaylist = props => {
  return (
    <header id="header-playlist">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-logo">
            <Link to="/" target="_blank">
              <img
                src={logo}
                alt="Rádio Košice"
                srcSet={`${logo2x} 2x`}
                className="img-responsive"
              />
            </Link>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-12 col-now-playing">
            <NowPlaying
              onClickYoutube={props.onClickYoutube.bind(null)}
              item={props.currentlyPlayingItem}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-player">
            <Player forcePause={props.forcePausePlayer} />
          </div>
        </div>
      </div>
    </header>
  );
};

HeaderPlaylist.propTypes = {
  currentlyPlayingItem: PropTypes.object.isRequired,
  onClickYoutube: PropTypes.func.isRequired,
  forcePausePlayer: PropTypes.bool.isRequired,
};

export default HeaderPlaylist;



// WEBPACK FOOTER //
// ./src/app/component/headerPlaylist/headerPlaylist.js